import { createAction, props } from '@ngrx/store';

import { CloseDialogPayload } from '../../models';

export const closeDialog = createAction('[DIALOG] CLOSE', props<{ payload: string | CloseDialogPayload }>());
